module.exports = __webpack_public_path__ + "static/assets/6475b197246327fb97759c7b08ecced3.png";